import { getfetchImg  } from '@/common/api/normal.js'
import { goHref } from '@/common/utils/common.js'
export default {
  data() {
    return {
      imglist: []
    }
  },
  methods: {
    // imgCode
    // 获取首页弹窗 --- h5HomeNewDialog
    // 获取H5挂件信息--- h5HomePendant
    // 首页轮播图--- homeBanner
    // 推广注册页图片  --- registerAndLoginBanner
    _getfetchImg(imgCode) { // 获取图片组
      getfetchImg({ imgCode }).then(([data, err, res]) => {
        if (!err) this.implementationFetched([data, res], imgCode)
      })
    },

    implementationFetched([data, res], imgCode) {
      this.imglist = data
    },
    
    handleImgClick({ imgClickLink }) {
      if (imgClickLink === '') return
      if (imgClickLink.indexOf('http') === -1) {
        if (this.$store.state.showLogin) this.$store.commit('SET_LOGIN_HIDE')
        if (this.$store.state.showRegister) this.$store.commit('SET_REGISTER', false)
        // console.log(imgClickLink.split('#')[1],imgClickLink.replace('#', ''))
        // this.$router.replace({ path: imgClickLink.replace('#', '') })
        // this.$router.push(imgClickLink.split('#')[1])
        let path = goHref(imgClickLink);
        if(path) {
          this.$router.push({path})
        }
      } else {
        window.open(imgClickLink, '_blank')
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/common/mixin/getfetchImg.js